import { render } from "./Afex.vue?vue&type=template&id=7bdc7da0&ts=true"
import script from "./Afex.vue?vue&type=script&lang=ts"
export * from "./Afex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__